import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import { Sunrise } from 'lucide-react'

/**
 * Shown once, right after a new account finishes onboarding.
 *
 * Deliberately not a question — it asks for nothing and changes no setting. It
 * simply tells the new member what being here means: that we are expecting them
 * at Fajr, and expecting them to help others get up too, inshaAllah. The single
 * button is an acknowledgement, not a choice.
 */
const FajrReminderModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation()

  if (!isOpen) return null

  return createPortal(
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-[200] p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="fajr-reminder-title"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-card border border-border rounded-xl max-w-sm w-full p-6 shadow-strong text-center">
        <div className="w-14 h-14 rounded-full bg-gradient-primary flex items-center justify-center mx-auto mb-4">
          <Sunrise className="w-7 h-7 text-primary-foreground" />
        </div>

        <h2 id="fajr-reminder-title" className="text-lg font-bold text-foreground mb-2">
          {t('fajrReminder.title')}
        </h2>

        <p className="text-sm text-muted-foreground leading-relaxed mb-6">
          {t('fajrReminder.body')}
        </p>

        <button
          autoFocus
          onClick={onClose}
          className="w-full px-4 py-2.5 bg-gradient-primary text-primary-foreground rounded-lg font-medium hover:opacity-90 transition-opacity shadow-soft focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
        >
          {t('fajrReminder.confirm')}
        </button>
      </div>
    </div>,
    document.body
  )
}

export default FajrReminderModal
